var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatsY({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#FFDD04",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9a2 2 0 01-2 2H6l-4 4V4a2 2 0 012-2h8a2 2 0 012 2v5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9h2a2 2 0 012 2v11l-4-4h-6a2 2 0 01-2-2v-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatsY);
export default __webpack_public_path__ + "static/media/icon-chats-y.ccd9e6618272a6bb3ccb75f30e84e201.svg";
export { ForwardRef as ReactComponent };